
import { cables } from "./coastNoaaCables";
import { sediment} from "./coastNoaaSediment";
import { slrGroup } from "./maps2CoastNoaaDcSlrGroup";
import { twlGroup } from "./njmapsCoastFloodTwlGroup";
import { bathymetry } from "./portalDemHillshade";
import {imperiled} from './portalImperiled';
import { njdotCdf } from "./portalNjdotCdf";
import { nsspStations} from "./portalNsspStations";
import { outfall } from "./portalOutfall";
import { reportArea } from "./portalReportAreas";
import { sav1968 } from "./portalSAV1968";
import { sav1979 } from "./portalSAV1979";
import { savPoly1979 } from "./portalPolySAV1979";
import { sav8587 } from "./portalSAV8587";
import { sav9699 } from "./portalSAV9699";
import { sav2003 } from "./portalSAV2003";
import { sav2023 } from "./portalSAV2023";
import { sav2009 } from "./portalSAV2009";
import {waterQual} from "./portalWaterQual";
import { bottom } from "./portalBottom";
import { hardBottom } from "./portalHardBottom";
import {inventoryGroup} from "./inventory/inventoryGroup";


//** removed - noaa submarine cable areas - dataset went away (https://coast.noaa.gov/arcgis/rest/services/OceanReports/SubmarineCableAreas/MapServer/0) */
//** removed - wrecks and obstructions - dataset went away ("https://wrecks.nauticalcharts.noaa.gov/arcgis/rest/services/public_wrecks/Wrecks_And_Obstructions/MapServer") */



export const habitat = {
  id: 'habitat',
  title: "Habitat and Environmental Layers",
  type: 'group',
  items: [
    bottom,
    hardBottom,
    cables,
    sediment,
    slrGroup,
    twlGroup,
    bathymetry,
    imperiled,
    inventoryGroup,
    njdotCdf,
    nsspStations,
    outfall,
    reportArea,
    sav1968,
    sav1979,
    savPoly1979,
    sav8587,
    sav9699,
    sav2003,
    sav2009,
    sav2023,
    waterQual,
  ],
}
